export default "__VITE_ASSET__a95cad47__"